import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-welcome-content',
  standalone: true,
  imports: [
    MatListModule,
    MatIconModule,
    MatButtonModule,
    RouterModule,
  ],
  template: `

<div class="scrolling">
    <div class="container center">
   <section class="highlight-section">
      <h2 class="style-1">Moderniza la gestión del alumbrado público</h2>
      <p class="p-highlight">
        Una solución digital creada por y para instaladores, técnicos y administradores del alumbrado público en Colombia.
      </p>
      <div style="width: 100%;">
        <iframe class="desktop" width="100%" src="https://www.youtube.com/embed/tr10WbE76Bk?autoplay=1&loop=1&mute=1&loop=1&controls=0&playlist=wOqkARf53Cc" frameborder="0" allow="autoplay"  encrypted-media allowfullscreen></iframe>
      </div>
    </section>
    <section>
      <h2 class="style-2 margin-top-60">Cumplimiento total con la norma RETILAP 2024</h2>
      <p class="text">
        Asegura que todas las luminarias instaladas y mantenidas cumplan con los requisitos técnicos y legales exigidos por la normativa vigente.
      </p>
    </section>
    <section>
      <h2 class="style-2 margin-top-60">Aplicación Web + App Móvil</h2>
      <p class="text">
        Una experiencia multiplataforma pensada para el trabajo en oficina y en campo.
      </p>
      <div class="flex-size-32">
        <div class="flex-2 desktop">
          <img src="/assets/images/welcome/desktop.png">
        </div>
        <div class="flex-1 mobile">
                
          <img src="/assets/images/welcome/mobile.png">
        </div>
        
      </div>
    </section>
    <section>
      <h2 class="style-2 margin-top-60">Georreferenciación y Registro Detallado de Luminarias</h2>
      <h3 class="text">
        Registra de manera precisa:
      </h3>
      <div class="mat-list-container">
        <mat-list>
            <mat-list-item class="mat-list-item-custom">
              <mat-icon matListItemIcon class="mat-list-icon-custom">location_on</mat-icon>
              <div matListItemTitle>Ubicación exacta vía GPS</div>
            </mat-list-item>
            <mat-list-item class="mat-list-item-custom">
              <mat-icon matListItemIcon class="mat-list-icon-custom">fact_check</mat-icon>
              <div matListItemTitle>Características técnicas según RETILAP</div>
            </mat-list-item>
            <mat-list-item class="mat-list-item-custom">
              <mat-icon matListItemIcon class="mat-list-icon-custom">format_list_bulleted</mat-icon>
              <div matListItemTitle>Historial de intervenciones por punto de iluminación</div>
            </mat-list-item>
        </mat-list>
      </div>
    </section>
    <section class="margin-top-60">
      <div class="flex-responsive">
        <div style="height: 600px;flex: 1; padding-right: 48px; ">
          <div class="column-relative">
            <iframe  class="mobile" src="https://www.youtube.com/embed/rYdHcn5fXiw?autoplay=1&loop=1&mute=1&loop=1&controls=0&playlist=5wXhTq_zWKQ" allowfullscreen></iframe>
            <div class="mobile-frame"> 
              <img src="/assets/images/welcome/frame.png">
            </div>
          </div>
        </div>  
        <div class="container-right">
          <h2 class="style-2">Gestión del Ciclo de Vida Operativo</h2>
          <h3 class="text">
            Controla todas las actividades en campo:
          </h3>
          <div>
            <mat-list>
              <mat-list-item class="mat-list-item-custom">
                <mat-icon matListItemIcon class="mat-list-icon-custom">check</mat-icon>
                <div matListItemTitle>Instalaciones nuevas</div>
              </mat-list-item>
              <mat-list-item class="mat-list-item-custom">
                <mat-icon matListItemIcon class="mat-list-icon-custom">check</mat-icon>
                <div matListItemTitle>Mantenimientos correctivos y preventivos</div>
              </mat-list-item>
              <mat-list-item class="mat-list-item-custom">
                <mat-icon matListItemIcon class="mat-list-icon-custom">check</mat-icon>
                <div matListItemTitle>Proyectos de modernización</div>
              </mat-list-item>
              <mat-list-item class="mat-list-item-custom">
                <mat-icon matListItemIcon class="mat-list-icon-custom">check</mat-icon>
                <div matListItemTitle>En una App que funciona sin conexión</div>
              </mat-list-item>
            </mat-list>
          </div>
        </div>
      </div>
    </section>
    <section>
      <h2 class="style-2 margin-top-60">Gestión y Trazabilidad de PQRS</h2>
      <h3 class="text">
        Recibe y administra:
      </h3>
      <div class="card-grid">
        <div class="card">
          <div>
            <mat-icon>face</mat-icon>
          </div>
          <div class="title">Atención al ciudadano</div>
          <div class="description text">
            Peticiones, quejas, reclamos y sugerencias de ciudadanos
          </div>
        </div>
        <div class="card">
          <div>
            <mat-icon>model_training</mat-icon>
          </div>
          <div class="title">Registro de incidencias</div>
          <div class="description text">
            Asocia automáticamente las incidencias con las luminarias afectadas
          </div>
        </div>
        <div class="card">
          <div>
            <mat-icon>description</mat-icon>
          </div>
          <div class="title">Trazabilidad</div>
          <div class="description text">
            Genera documentación y trazabilidad digital de cada caso
          </div>
        </div>
      </div>
    </section>
    <section>
      <div>
        <mat-icon class="size">cloud</mat-icon>
      </div>
      <h2 class="style-2">Documentación Digital en la Nube</h2>
      <mat-list class="list-center">
        <mat-list-item class="mat-list-item-custom">
          <mat-icon matListItemIcon class="mat-list-icon-custom">check</mat-icon>
          <div matListItemTitle>Generación automática de órdenes y permisos de trabajo</div>
        </mat-list-item>
        <mat-list-item class="mat-list-item-custom">
          <mat-icon matListItemIcon class="mat-list-icon-custom">check</mat-icon>
          <div matListItemTitle>Firma digital con huella del usuario</div>
        </mat-list-item>
        <mat-list-item class="mat-list-item-custom">
          <mat-icon matListItemIcon class="mat-list-icon-custom">check</mat-icon>
          <div matListItemTitle>Almacenamiento seguro de fotos, reportes y documentación</div>
        </mat-list-item>
      </mat-list>
    </section>
    <section>
      <div>
        <mat-icon class="size">bar_chart</mat-icon>
      </div>
      <h2 class="style-2">Informes y Reportes de Cumplimiento</h2>
      <h3 class="text">Obtén reportes detallados para:</h3>
      <mat-list class="list-center">
        <mat-list-item class="mat-list-item-custom">
          <mat-icon matListItemIcon class="mat-list-icon-custom">check</mat-icon>
          <div matListItemTitle>Auditar operaciones</div>
        </mat-list-item>
        <mat-list-item class="mat-list-item-custom">
          <mat-icon matListItemIcon class="mat-list-icon-custom">check</mat-icon>
          <div matListItemTitle>Verificar cumplimiento con RETILAP</div>
        </mat-list-item>
        <mat-list-item class="mat-list-item-custom">
          <mat-icon matListItemIcon class="mat-list-icon-custom">check</mat-icon>
          <div matListItemTitle>Tomar decisiones basadas en datos</div>
        </mat-list-item>
      </mat-list>
    </section>
    <section>
      <div>
        <mat-icon class="size">group_add</mat-icon>
      </div>
      <h2 class="style-2">Roles y Permisos Personalizados</h2>
      <h3 class="text">Define permisos específicos para:</h3>
      <mat-list class="list-center">
        <mat-list-item class="mat-list-item-custom">
          <mat-icon matListItemIcon class="mat-list-icon-custom">check</mat-icon>
          <div matListItemTitle>Técnicos</div>
        </mat-list-item>
        <mat-list-item class="mat-list-item-custom">
          <mat-icon matListItemIcon class="mat-list-icon-custom">check</mat-icon>
          <div matListItemTitle>Supervisores</div>
        </mat-list-item>
        <mat-list-item class="mat-list-item-custom">
          <mat-icon matListItemIcon class="mat-list-icon-custom">check</mat-icon>
          <div matListItemTitle>Administradores</div>
        </mat-list-item>
        <mat-list-item class="mat-list-item-custom">
          <mat-icon matListItemIcon class="mat-list-icon-custom">check</mat-icon>
          <div matListItemTitle>Entidades territoriales / interventores</div>
        </mat-list-item>
      </mat-list>
    </section>
    <section>
      <h2 class="style-2 margin-top-60">¿Listo para modernizar la gestión del alumbrado público?</h2>
      <p class="text">
      Contáctanos hoy y lleva tu operación al siguiente nivel.
      </p>
    </section>
    </div>
    <div class="footer">
      <button mat-button [routerLink]="['/welcome/contact-pqr']">REPORTAR PQR</button>
      <button mat-button [routerLink]="['/welcome/map']">VER MAPA</button>
      <button mat-button>CONTACTAR</button>      
    </div>
    </div>
  `,
  styleUrls: ['./welcome-content.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WelcomeContentComponent {
  
}
